namespace GeniuzPOS.ReportMasterData {
    export class Report_1315Columns {
        static columnsKey = 'ReportMasterData.Report_1315';
    }
}
